import React from 'react';
import {
    faLink
} from '@fortawesome/free-solid-svg-icons';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import {
    Typography,
    Box,
    Link as LinkText,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material/styles'
import SubscribeToView from 'components/Common/SubscribeToView';
// import { useSelector } from 'react-redux'

const LinkTextStyle = styled(Box)(() => ({
  color: '#0A78CD',
  fontWeight: 'bold',
  cursor: 'pointer',
  textDecoration: 'none',
  fontSize: '12px',
  fontFamily: 'poppins',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

const FreeUser = () => {
  return (
    <Box flexDirection="column" display="flex" alignItems="baseline">
      <Box display="flex" alignItems="center">
        <LinkText variant="body2">
          <FacebookIcon sx={{ fontSize: 20, color: '#1773ea' }} />
          &nbsp;Facebook
        </LinkText>
        <Typography className="py-1" variant="body2">
          <SubscribeToView />
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <LinkText variant="body2">
          <TwitterIcon sx={{ fontSize: 20, color: '#4da6e9' }} />
          &nbsp;Twitter
        </LinkText>
        <Typography className="py-1" variant="body2">
          <SubscribeToView />
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <LinkText variant="body2">
          <FontAwesomeIcon fontSize="18px" className="font-weight-bold" icon={faLink} />
          &nbsp;Linkedln
        </LinkText>
        <Typography className="py-1" variant="body2">
          <SubscribeToView />
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <LinkText variant="body2">
          <InstagramIcon sx={{ fontSize: 20, color: '#c4255f' }} />
          &nbsp;Instagram
        </LinkText>
        <Typography className="py-1" variant="body2">
          <SubscribeToView />
        </Typography>
      </Box>
    </Box>
  )
}

const SocialComponent = ({ data, isFreeAccount }) => {
  const { details } = data
  // const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const showClaimed = !isFreeAccount

  return (
    <Box display={'flex'} gap="7px" alignItems="baseline">
      <Box display="flex" flexDirection="column">
        {showClaimed ? (
          <Box flexDirection="column" gap="7px" display="flex" alignItems="baseline" sx={{ wordBreak: 'break-word' }}>
            {details.socialFacebook && (
              <Box display="flex" alignItems="baseline">
                <Typography component="span" variant="body2" fontWeight="600" whiteSpace="nowrap">
                  <FacebookIcon sx={{ fontSize: 20, color: '#1773ea' }} />
                  &nbsp;Facebook:&nbsp;
                </Typography>
                <LinkText target="_blank" href={details.socialFacebook} variant="body2" sx={{ textDecoration: 'none' }}>
                  <LinkTextStyle>{details.socialFacebook}</LinkTextStyle>
                </LinkText>
              </Box>
            )}
            {details.socialTwitter && (
              <Box display="flex" alignItems="baseline">
                <Typography component="span" variant="body2" fontWeight="600" whiteSpace="nowrap">
                  <TwitterIcon sx={{ fontSize: 20, color: '#4da6e9' }} />
                  &nbsp;Twitter:&nbsp;
                </Typography>
                <LinkText target="_blank" href={details.socialTwitter} variant="body2" sx={{ textDecoration: 'none' }}>
                  <LinkTextStyle>{details.socialTwitter}</LinkTextStyle>
                </LinkText>
              </Box>
            )}
            {details.socialLinkedIn && (
              <Box display="flex" alignItems="baseline">
                <Typography component="span" variant="body2" fontWeight="600" whiteSpace="nowrap">
                  <FontAwesomeIcon fontSize="18px" className="font-weight-bold" icon={faLink} />
                  &nbsp;Linkedln:&nbsp;
                </Typography>
                <LinkText target="_blank" href={details.socialLinkedIn} variant="body2" sx={{ textDecoration: 'none' }}>
                  <LinkTextStyle>{details.socialLinkedIn}</LinkTextStyle>
                </LinkText>
              </Box>
            )}
            {details.socialInstagram && (
              <Box display="flex" alignItems="baseline">
                <Typography component="span" variant="body2" fontWeight="600" whiteSpace="nowrap">
                  <InstagramIcon sx={{ fontSize: 20, color: '#c4255f' }} />
                  &nbsp;Instagram:&nbsp;
                </Typography>
                <LinkText
                  href={details.socialInstagram}
                  target="_blank"
                  variant="body2"
                  sx={{ textDecoration: 'none' }}
                >
                  <LinkTextStyle>{details.socialInstagram}</LinkTextStyle>
                </LinkText>
              </Box>
            )}
          </Box>
        ) : (
          <FreeUser data={data} />
        )}
      </Box>
    </Box>
  )
}

export default SocialComponent;